module.exports = "require.include";


/*****************
 ** WEBPACK FOOTER
 ** ./chunks/parsing/require.include.js
 ** module id = 3
 ** module chunks = 0
 **/